export default {
    routerName: '広告管理',
    ad: {
        searchName: '検索条件',
        name: '広告名',
        spaceName: '広告位',
        sortOrder: 'ソート',
        hits: '閲覧量',
        category: '類別',
        hot: '人気',
        recommend: '推薦',
        recommendTop: '推薦TOP',
        topic: '話題',
        type: 'タイプ',
        typeImage: '画像',
        typeVideo: 'ビデオ',
        typeRadio: '音声',
        pattern: '広告パターン',
        startTime: 'パターン開始日時',
        endTime: 'パターン終了日時',
        patternHits: 'パターン閲覧量',
        pDay: '日',
        pHits: '閲覧量',
        createTime: '作成日付',
        status: '状態',
        open: '有効',
        close: '無効',
    },
    table: {
        id: 'ID',
        name: '広告名',
        spaceName: '広告位',
        type: 'タイプ',
        pattern: '広告パターン',
        startTime: 'パターン開始日時',
        endTime: 'パターン終了日時',
        patternHits: 'パターン閲覧量',
        category: '類別',
        hot: '気',
        recommend: '薦',
        recommendTop: '薦T',
        topic: '話',
        sortOrder: 'ソート',
        hits: '閲覧量',
        createBy: '作成者',
        createTime: '作成日付',
        status: '状態',
        open: '有効',
        close: '無効',
    },
};
